
<script>
	import listBase from '@_system/components/base/list.vue'
	import footerIndex from './footer/index.vue'
	export default {
		extends: listBase,
		name: 'crmcustomertrackIndex',
		props: {

		},
		render(h) {
			this.$slots.footer = [
				<div style="position: relative;width: 100%;height:100%;">
					<footer-index list={this} ref="footer" row={this.currentrow} />
				</div>
			]
			return listBase.render.call(this, h)
		},
		data() {
			return {
				moduleName: 'crmcustomertrack',
				windowName: '待跟进客户',
				exportData: [],
				currentrow:null,
				distributionShow:false
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			flowup(row) {
				this.addformShow({row:row})
			},	
			addformShow(extra={}) {
				if (this.windowType == 'window') {
					let res = this.$router.resolve({
						name: 'add',
						query: {
							name: 'crmcustomerflowup',
							id: 0,
							controlltype: 1,
							windowName: '新建回访单',
							foreingKey: JSON.stringify({}),
							extra: JSON.stringify(extra)
						}
					})
					let win = window.open(res.href, 'crmcustomerflowup' + 'add',
						this.$store.state.system.windowConfig)
					win.onload = () => {
			
					}
				} else {
					this.formModule = {
						name: 'crmcustomerflowup',
						id: 0,
						controlltype: 1,
						windowName: '新建回访单',
						foreingKey: {},
						extra: extra
					}
					this.formwindowShow = true
				}
			},
			cellClick({row}) {
				this.currentrow = row
				this.$nextTick(()=>{
					this.$refs.footer.inittab()
				})
			},
			editformShow(row) {
				if (this.windowType == 'window') {
					let res = this.$router.resolve({
						name: 'update',
						query: {
							name: 'crmcustomer',
							id: row.id,
							controlltype: 2,
							windowName: '编辑' + this.windowName,
						}
					})
					let win = window.open(res.href, 'crmcustomer' + 'edit',
						this.$store.state.system.windowConfig)
					win.onload = () => {
			
					}
				} else {
					this.formModule = {
						name: 'crmcustomer',
						id: row.id,
						controlltype: 2,
						windowName: '编辑' + this.windowName,
						foreingKey: {},
						extra: {}
					}
					this.formwindowShow = true
				}
			}

		},
		components: {
			footerIndex	
		}
	}
</script>
